import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Layout from "./components/Layout";
import Home from "./pages/Home";
import WhyChooseUs from "./pages/WhyChooseUs";
import Channels from "./pages/Channels";
import Contact from "./pages/Contact";
import ISPSolutions from "./pages/ISPSolutions";
import Demo from "./pages/Demo";
import Admin from "./pages/Admin";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import { Toaster } from "sonner";

// Wrapper to conditionally render Layout
const AppRoutes = () => {
  const location = useLocation();
  const isAdminRoute = location.pathname.startsWith('/admin');

  if (isAdminRoute) {
    return (
      <Routes>
        <Route path="/admin" element={<Admin />} />
      </Routes>
    );
  }

  return (
    <Layout>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/why-choose-us" element={<WhyChooseUs />} />
        <Route path="/channels" element={<Channels />} />
        <Route path="/channels/:broadcasterId" element={<Channels />} />
        <Route path="/demo" element={<Demo />} />
        <Route path="/isp-solutions" element={<ISPSolutions />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
      </Routes>
    </Layout>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AppRoutes />
      </BrowserRouter>
      <Toaster position="top-right" />
    </div>
  );
}

export default App;
